import React from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';

export default function UserDetail({ users }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const user = users[parseInt(id, 10)];

  if (!user) return <div>User not found.</div>;

  return (
    <div>
      <h2>User Profile</h2>
      <p><b>Name:</b> {user.name}</p>
      <p><b>Email:</b> {user.email}</p>
      <button onClick={() => navigate(-1)}>Back</button>
      <Link to={`/edit/${id}`}><button>Edit</button></Link>
    </div>
  );
}
